<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.START"
    :handler="
      async (data) => {
        if (!data?.group || !data?.option) return;
        group = data.group;
        option = data.option;
        $refs.selectorDialog.show();
      }
    "
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.OPTIONS.SELECTED"
    :handler="
      () => {
        $refs.selectorDialog.hide();
      }
    "
  />
  <DialogComponent ref="selectorDialog" type="bottomsheet" hideCloseButton>
    <ServicesList :group="group" :option="option" :iconOnOptions="true" />
  </DialogComponent>
</template>

<script setup>
import { ref } from 'vue';
const group = ref(null);
const option = ref(null);
</script>
